import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import { Col, Container, Row } from "reactstrap";
import { Card } from "primereact/card";
import { Badge } from "primereact/badge";
import { Toast } from "primereact/toast";
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { AutoComplete } from "primereact/autocomplete";
import CompanySelector from "ATSComponents/Common/CompanySelector";
import {
    Input,
    InputGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Button as RSButton,
} from "reactstrap";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";
const KanbanView = () => {
  const toast = useRef(null);
  const containerRef = useRef(null);
  const scrollTimerRef = useRef(null);

  // State to manage the kanban data
  const [kanbanData, setKanbanData] = useState({});
  const [originalData, setOriginalData] = useState({});
  // State to manage dynamic columns
  const [columns, setColumns] = useState([]);

  // State for dynamic filter options
  const [recruiters, setRecruiters] = useState([]);
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [jobTitleOptions, setJobTitleOptions] = useState([]);
  const [jobOptions, setJobOptions] = useState([]);

  document.title = "ATS - Candidates Pipeline"

   const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);
  
    const handleCompanyChange = (company) => {
      if (company?.company_id) {
          setCompanyId(company?.company_id);
          // fetchUserManagementDetails(company.company_i)
          // getDesignation(company.company_id);
      }
    };
const [loading, setLoading] = useState(true);

  // Fetch columns from API
  const fetchColumns = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-stages/?company_id=${companyId}`);
      const apiColumns = response.data.results;
      
      const transformedColumns = apiColumns.map(stage => ({
        id: stage.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''),
        title: stage.name
      }));

      setColumns(transformedColumns);

      const initialData = transformedColumns.reduce((acc, column) => {
        acc[column.id] = [];
        return acc;
      }, {});
      setKanbanData(initialData);
      setOriginalData(initialData);
    } catch (error) {
      console.error('Error fetching columns:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to fetch Kanban columns',
        life: 3000
      });
    }
  };

  // Fetch filter data from APIs
  const fetchRecruiters = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-hiring-managers/?company_id=${companyId}`);
      const apiRecruiters = response.data.results;
      const transformedRecruiters = apiRecruiters.map(recruiter => ({
        name: recruiter?.first_name || "",
        id: recruiter.id
      }));
      setRecruiters(transformedRecruiters);
    } catch (error) {
      console.error('Error fetching recruiters:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to fetch recruiters',
        life: 3000
      });
    }
  };

  const fetchJobStatuses = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-Job-status/?company_id=${companyId}`);
      const apiStatuses = response.data.results;
      const transformedStatuses = apiStatuses.map(status => ({
        label: status.job_status,
        id: status.id
      }));
      setJobStatusOptions(transformedStatuses);
    } catch (error) {
      console.error('Error fetching job statuses:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to fetch job statuses',
        life: 3000
      });
    }
  };

  const fetchJobs = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-jobs/?company_id=${companyId}`);        
      const apiJobs = response.data.results;
      
      // Transform for job titles
      const uniqueJobTitles = [...new Set(apiJobs.map(job => job.job_title))];
      const transformedJobTitles = uniqueJobTitles.map(title => ({
        name: title,
        code: title
      }));
      setJobTitleOptions(transformedJobTitles);

      // Transform for job IDs
      const transformedJobs = apiJobs.map(job => ({
        name: job.job_number,
        code: job.job_number
      }));
      setJobOptions(transformedJobs);
    } catch (error) {
      console.error('Error fetching jobs:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to fetch jobs',
        life: 3000
      });
    }
  };

  // Fetch candidate data from API
  const fetchData = async () => {
    try {
      const response = await axios.get(`/api/v1/stages/job_candidates_by_stage/?company_id=${companyId}`);
      const transformedData = transformApiData(response.data.results);
      setKanbanData(transformedData);
      setOriginalData(transformedData);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to fetch Kanban data',
        life: 3000
      });
    }
  };

// useEffect(() => {
//   fetchColumns();
//   fetchRecruiters();
//   fetchJobStatuses();
//   fetchJobs();
// }, [companyId]); 
useEffect(() => {
  if (columns.length > 0) {
    fetchData();
  }
}, [columns, companyId]); 

  // const transformApiData = (apiData) => {
  //   const transformedData = { ...kanbanData };

  //   const stageNameMap = columns.reduce((map, column) => {
  //     map[column.title.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')] = column.id;
  //     return map;
  //   }, {});

  //   apiData.forEach(stage => {
  //     const stageName = stage.stage_name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  //     const mappedStage = stageNameMap[stageName];
  //     if (mappedStage && transformedData.hasOwnProperty(mappedStage)) {
  //       transformedData[mappedStage] = stage.candidates.map(candidate => ({
  //         id: `c${candidate.job_candidate_id}`,
  //         name: candidate.candidate_name,
  //         jobTitle: candidate.job.job_title,
  //         company: candidate.job.company_name,
  //         startDate: candidate.job.job_start_date,
  //         jobId: candidate.job.job_number,
  //         recruiter: candidate.job.hiring_manager_name,
  //         jobStatus: candidate.type,
  //         email: candidate.candidate_email,
  //         phone: candidate.phone,
  //         city: candidate.city,
  //         state: candidate.job.location
  //       }));
  //     } else {
  //       console.warn(`Unmapped stage: ${stage.stage_name}`);
  //     }
  //   });
  //   return transformedData;
  // };

  // Filter states
  const transformApiData = (apiData) => {
  const transformedData = {};
  const stageNameMap = columns.reduce((map, column) => {
    map[column.title.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')] = column.id;
    return map;
  }, {});

  // Initialize all columns with empty arrays
  columns.forEach(column => {
    transformedData[column.id] = [];
  });

  apiData.forEach(stage => {
    const stageName = stage.stage_name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
    const mappedStage = stageNameMap[stageName];
    if (mappedStage) {
      transformedData[mappedStage] = stage.candidates.map(candidate => ({
        id: `c${candidate.job_candidate_id}`,
        name: candidate.candidate_name,
        jobTitle: candidate.job.job_title,
        company: candidate.job.company_name,
        startDate: candidate.job.job_start_date,
        jobId: candidate.job.job_number,
        recruiter: candidate.job.hiring_manager_name,
        jobStatus: candidate.type,
        email: candidate.candidate_email,
        phone: candidate.phone,
        city: candidate.city,
        state: candidate.job.location,
        reason: candidate.reason || ""
      }));
    } else {
      console.warn(`Unmapped stage: ${stage.stage_name}`);
    }
  });
  return transformedData;
};

  const [selectedRecruiter, setSelectedRecruiter] = useState(null);
  const [selectedJobStatus, setSelectedJobStatus] = useState(null);
  const [selectedJobTitle, setSelectedJobTitle] = useState(null);
  const [candidateName, setCandidateName] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [selectedJob, setSelectedJob] = useState(null);

  // Drag-and-drop states
  const [draggedItemId, setDraggedItemId] = useState(null);
  const [dragSourceColumn, setDragSourceColumn] = useState(null);
  const [dragOverItemId, setDragOverItemId] = useState(null);
  const [dragPosition, setDragPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [currentHoverColumn, setCurrentHoverColumn] = useState(null);

  // Expanded columns state
  const [expandedColumns, setExpandedColumns] = useState({});
  const CARDS_TO_SHOW = 4;

  // Modify handleClear to refetch unfiltered data
const handleClear = async () => {
  setSelectedRecruiter(null);
  setSelectedJobStatus(null);
  setSelectedJobTitle(null);
  setCandidateName('');
  setSelectedCompany(null);
  setEmail('');
  setPhone('');
  setCity('');
  setState('');
  setSelectedJob(null);

  // Refetch unfiltered data
  await fetchData();

  toast.current?.show({
    severity: 'info',
    summary: 'Filters Cleared',
    detail: 'All filters have been cleared',
    life: 3000,
  });
};

const applyFilters = async () => {
  try {
    // Build query parameters based on filter states
    const queryParams = new URLSearchParams();

    // Only append valid filter values
    if (selectedRecruiter && selectedRecruiter.id) {
      queryParams.append('recruiter_id', selectedRecruiter.id);
    }
    if (selectedJobStatus && selectedJobStatus.id) {
      queryParams.append('job_status', selectedJobStatus.id);
    }
    if (selectedJobTitle && selectedJobTitle.code) {
      queryParams.append('job_title', selectedJobTitle.code);
    }
    if (candidateName) {
      queryParams.append('candidate_name', candidateName);
    }
    if (selectedCompany && selectedCompany.name) {
      queryParams.append('company_name', selectedCompany.name);
    }
    if (email) {
      queryParams.append('email', email);
    }
    if (phone) {
      queryParams.append('phone', phone);
    }
    if (city) {
      queryParams.append('city', city);
    }
    if (state) {
      queryParams.append('state', state);
    }
    if (selectedJob && selectedJob.code) {
      queryParams.append('job_no', selectedJob.code);
    }

    // Construct the API URL with query parameters
   const apiUrl = `/api/v1/stages/job_candidates_by_stage/?company_id=${companyId}${
      queryParams.toString() ? `&${queryParams.toString()}` : ''}`;


    // Fetch filtered data from the API
    const response = await axios.get(apiUrl);
    const transformedData = transformApiData(response.data.results);

    // Update kanban data with filtered results
    setKanbanData(transformedData);

    toast.current?.show({
      severity: 'success',
      summary: 'Filters Applied',
      detail: 'The view has been updated based on your filters',
      life: 3000,
    });
  } catch (error) {
    console.error('Error applying filters:', error);
    toast.current?.show({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to apply filters',
      life: 3000,
    });
  }
};
  // useEffect(() => {
  //   handleClear();
  // }, []); 
  const toggleColumnExpand = (columnId) => {
    setExpandedColumns(prev => ({
      ...prev,
      [columnId]: !prev[columnId]
    }));
  };

  useEffect(() => {
    if (!isDragging || !containerRef.current) return;

    const container = containerRef.current;
    const containerRect = container.getBoundingClientRect();
    const scrollSpeed = 15;
    const scrollThreshold = 100;

    if (scrollTimerRef.current) {
      clearInterval(scrollTimerRef.current);
      scrollTimerRef.current = null;
    }

    if (dragPosition.x > containerRect.right - scrollThreshold) {
      scrollTimerRef.current = setInterval(() => {
        container.scrollLeft += scrollSpeed;
      }, 30);
    } else if (dragPosition.x < containerRect.left + scrollThreshold) {
      scrollTimerRef.current = setInterval(() => {
        container.scrollLeft -= scrollSpeed;
      }, 30);
    }

    return () => {
      if (scrollTimerRef.current) {
        clearInterval(scrollTimerRef.current);
      }
    };
  }, [isDragging, dragPosition]);

  const onDragOver = (event, columnId = null) => {
    event.preventDefault();
    setDragPosition({ x: event.clientX, y: event.clientY });
    if (columnId && columnId !== currentHoverColumn) {
      setCurrentHoverColumn(columnId);
    }
  };

  const onDragStart = (event, itemId, columnId) => {
    event.dataTransfer.setData('itemId', itemId);
    event.dataTransfer.setData('sourceColumnId', columnId);
    setDraggedItemId(itemId);
    setDragSourceColumn(columnId);
    setIsDragging(true);

    if (event.target.classList) {
      event.target.classList.add('dragging');
    }
  };

  const onDragEnter = (event, itemId) => {
    if (draggedItemId !== itemId) {
      setDragOverItemId(itemId);
    }
  };

  // const onDragEnd = (event) => {
  //   if (event.target.classList) {
  //     event.target.classList.remove('dragging');
  //   }

  //   setDragOverItemId(null);
  //   setIsDragging(false);
  //   setCurrentHoverColumn(null);
  //   setDraggedItemId(null);
  //   setDragSourceColumn(null);

  //   if (scrollTimerRef.current) {
  //     clearInterval(scrollTimerRef.current);
  //     scrollTimerRef.current = null;
  //   }
  // };
const onDragEnd = (event) => {
  if (event.target.classList) {
    event.target.classList.remove('dragging');
  }
  setDragOverItemId(null);
  setIsDragging(false);
  setCurrentHoverColumn(null);
  setDraggedItemId(null);
  setDragSourceColumn(null);
  if (scrollTimerRef.current) {
    clearInterval(scrollTimerRef.current);
    scrollTimerRef.current = null;
  }
};

  // const onDrop = async (event, dropColumnId) => {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   const itemId = event.dataTransfer.getData('itemId');
  //   const sourceColumnId = event.dataTransfer.getData('sourceColumnId');

  //   if (!itemId || !sourceColumnId || !draggedItemId) return;

  //   if (sourceColumnId === dropColumnId && dragOverItemId && itemId !== dragOverItemId) {
  //     const newFilteredData = { ...kanbanData };
  //     const newOriginalData = { ...originalData };
  //     const sourceColumnItems = [...newFilteredData[sourceColumnId]];
  //     const itemIndex = sourceColumnItems.findIndex(item => item.id === itemId);

  //     if (itemIndex !== -1) {
  //       const movedItem = sourceColumnItems[itemIndex];
  //       const originalSourceItems = [...newOriginalData[sourceColumnId]];
  //       const originalItemIndex = originalSourceItems.findIndex(item => item.id === itemId);

  //       sourceColumnItems.splice(itemIndex, 1);
  //       const dropIndex = sourceColumnItems.findIndex(item => item.id === dragOverItemId);
  //       if (dropIndex !== -1) {
  //         sourceColumnItems.splice(dropIndex, 0, movedItem);
  //         newFilteredData[sourceColumnId] = sourceColumnItems;

  //         if (originalItemIndex !== -1) {
  //           originalSourceItems.splice(originalItemIndex, 1);
  //           const originalDropIndex = originalSourceItems.findIndex(item => item.id === dragOverItemId);
  //           if (originalDropIndex !== -1) {
  //             originalSourceItems.splice(originalDropIndex, 0, movedItem);
  //           } else {
  //             originalSourceItems.push(movedItem);
  //           }
  //           newOriginalData[sourceColumnId] = originalSourceItems;
  //         }
  //         setKanbanData(newFilteredData);
  //         setOriginalData(newOriginalData);
  //       }
  //     }
  //   } else if (sourceColumnId !== dropColumnId) {
  //     try {
  //       const jobCandidateId = itemId.replace('c', '');
  //       const stageNameMap = columns.reduce((map, column) => {
  //         map[column.id] = column.title;
  //         return map;
  //       }, {});
  //       const apiStageName = stageNameMap[dropColumnId];

  //       await axios.put(`/api/v1/change-stage/${jobCandidateId}/`, {
  //         stage: apiStageName
  //       });

  //       await fetchData();

  //       toast.current?.show({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: `Candidate moved to ${columns.find(col => col.id === dropColumnId).title}`,
  //         life: 3000
  //       });
  //     } catch (error) {
  //       console.error('Error updating stage:', error);
  //       const backendMessage =
  //         error.response?.data?.error ||
  //         error.response?.data?.detail ||
  //         'Failed to update candidate stage';
  //       toast.current?.show({
  //         severity: 'warn',
  //         summary: 'Warning',
  //         detail: backendMessage,
  //         life: 3000
  //       });
  //     }
  //   }

  //   setDraggedItemId(null);
  //   setDragSourceColumn(null);
  //   setDragOverItemId(null);
  //   setIsDragging(false);
  // };
const onDrop = async (event, dropColumnId) => {
  event.preventDefault();
  event.stopPropagation();
  const itemId = event.dataTransfer.getData("itemId");
  const sourceColumnId = event.dataTransfer.getData("sourceColumnId");
  if (!itemId || !sourceColumnId || !draggedItemId) return;

  // Only show the modal if the candidate is moved to a different stage
  // if (sourceColumnId !== dropColumnId) {
  //   setCurrentMove({
  //     itemId,
  //     sourceColumnId,
  //     dropColumnId,
  //   });
  //   setShowReasonModal(true);
  const sourceIndex = columns.findIndex(col => col.id === sourceColumnId);
  const targetIndex = columns.findIndex(col => col.id === dropColumnId);
  if (sourceIndex < targetIndex) {
    setCurrentMove({
      itemId,
      sourceColumnId,
      dropColumnId,
    });
    setShowReasonModal(true);
  } else {
    toast.current?.show({
      severity: "warn",
      summary: "Warning",
      detail: "Moving backward is not allowed.",
      life: 3000,
    });
  }
};
useEffect(() => {
  return () => {
    setDraggedItemId(null);
    setDragSourceColumn(null);
    setDragOverItemId(null);
    setIsDragging(false);
    setCurrentHoverColumn(null);
  };
}, []);

const [isSubmitting, setIsSubmitting] = useState(false);
const handleConfirmMove = async () => {
  const { itemId, sourceColumnId, dropColumnId } = currentMove;
  if (!itemId || !sourceColumnId || !dropColumnId || sourceColumnId === dropColumnId) {
    setShowReasonModal(false);
    setMoveReason("");
    setCurrentMove({
      itemId: null,
      sourceColumnId: null,
      dropColumnId: null,
    });
    return;
  }
  setIsSubmitting(true);
  try {
    const jobCandidateId = itemId.replace('c', '');
    const stageNameMap = columns.reduce((map, column) => {
      map[column.id] = column.title;
      return map;
    }, {});
    const apiStageName = stageNameMap[dropColumnId];
    // await axios.put('/api/v1/change-stage/drag-stage/', {
    //   job_candidate_id: jobCandidateId,
    //   stage: apiStageName,
    //   reason: moveReason,
    // });
    await axios.put(`/api/v1/change-stage/${jobCandidateId}/?company_id=${companyId}`, {
      stage: apiStageName,
      reason: moveReason,
    });
    const newKanbanData = { ...kanbanData };
    let movedItem = null;
    const sourceColumnItems = [...newKanbanData[sourceColumnId]];
    const itemIndex = sourceColumnItems.findIndex(item => item.id === itemId);
    if (itemIndex !== -1) {
      movedItem = sourceColumnItems[itemIndex];
      sourceColumnItems.splice(itemIndex, 1);
      newKanbanData[sourceColumnId] = sourceColumnItems;
    }
    const targetColumnItems = [...newKanbanData[dropColumnId]];
    if (movedItem) {
      movedItem.moveReason = moveReason;
       console.log("moveReason set:", movedItem.moveReason)
      targetColumnItems.push(movedItem);
      newKanbanData[dropColumnId] = targetColumnItems;
    }

    setKanbanData(newKanbanData);
    await fetchData();

    toast.current?.show({
      severity: "success",
      summary: "Success",
      detail: `Candidate moved to ${apiStageName} (Reason: ${moveReason})`,
      life: 3000,
    });
  } catch (error) {
    console.error('Error updating stage:', error);
    const backendMessage =
      error.response?.data?.error ||
      error.response?.data?.detail ||
      'Failed to update candidate stage';
    toast.current?.show({
      severity: 'error',
      summary: 'Error',
      detail: backendMessage,
      life: 3000,
    });
  } finally {
    setIsSubmitting(false);
    setShowReasonModal(false);
    setMoveReason("");
    setCurrentMove({
      itemId: null,
      sourceColumnId: null,
      dropColumnId: null,
    });
  }
};


  const handleColumnDragOver = (event, columnId) => {
    onDragOver(event, columnId);

    if (containerRef.current) {
      const columnElement = document.getElementById(`column-${columnId}`);
      if (columnElement) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const columnRect = columnElement.getBoundingClientRect();

        if (columnRect.left > containerRect.right) {
          containerRef.current.scrollLeft += 10;
        } else if (columnRect.right < containerRect.left) {
          containerRef.current.scrollLeft -= 10;
        }
      }
    }
  };

  const renderCandidateCard = (item, columnId) => {
    console.log("item",item)
    return (
      <div
        key={item.id}
        id={`card-${item.id}`}
        draggable={true}
        onDragStart={(e) => onDragStart(e, item.id, columnId)}
        onDragEnd={onDragEnd}
        onDragEnter={(e) => onDragEnter(e, item.id)}
        onDragOver={onDragOver}
        className={`cursor-move card-container ${dragOverItemId === item.id ? 'drag-over' : ''}`}
        style={{
          cursor: 'move',
          transition: 'all 0.3s ease',
          position: 'relative',
          marginBottom: '8px'
        }}
      >
        <Card className="p-2 shadow-sm border bg-white">
          <div className="text-gray-800 font-medium">{item.name}</div>
          <div className="text-sm text-gray-600">{item.jobTitle}</div>
          <div className="text-xs text-gray-400">{item.company}</div>
          <div className="flex justify-between text-xs text-gray-400 dates">
            <span className="me-3">{item.jobId}</span>
           {item.startDate && <span>Start: {item.startDate}</span>}
          </div>
           {item.reason && (
          <div className="text-xs text-gray-500 mt-1">
            <small>Reason: {item.reason}</small>
          </div>
        )}
        </Card>
        {dragOverItemId === item.id && draggedItemId !== item.id && (
          <div
            className="drop-indicator"
            style={{
              position: 'absolute',
              top: '-4px',
              left: 0,
              right: 0,
              height: '4px',
              backgroundColor: '#3b82f6',
              borderRadius: '2px',
              zIndex: 10
            }}
          ></div>
        )}
      </div>
    );
  };

  const getVisibleCards = (columnId) => {
    const cards = kanbanData[columnId] || [];
    if (cards.length <= CARDS_TO_SHOW || expandedColumns[columnId]) {
      return cards;
    }
    return cards.slice(0, CARDS_TO_SHOW);
  };

  const hasMoreCards = (columnId) => {
    const cards = kanbanData[columnId] || [];
    return cards.length > CARDS_TO_SHOW;
  };

  useEffect(() => {
    const handleGlobalDragOver = (e) => {
      if (isDragging) {
        e.preventDefault();
        setDragPosition({ x: e.clientX, y: e.clientY });
      }
    };

    document.addEventListener('dragover', handleGlobalDragOver);

    return () => {
      document.removeEventListener('dragover', handleGlobalDragOver);
    };
  }, [isDragging]);

  const [value, setValue] = useState('');
  const [items, setItems] = useState([]);

  const names = [
    "Infosys", "Cognizant", "Capgemini", "CA Technologies", "L&T Mindtree",
    "Ram Software Services", "Citel Global Communication", "Tarun Digital Media",
    "Sai Digital Media", "Mahesh Digital Media", "Twitter", "Uber", "TCS",
    "Wipro", "HCL", "Deloitte", "Accenture", "IBM", "SAP", "Dell", "HP",
    "Cisco", "Adobe", "PayPal", "Spotify", "Atlassian"
  ];

  const search = (event) => {
    let filteredNames = names.filter(name => name.toLowerCase().includes(event.query.toLowerCase()));
    setItems(filteredNames);
  };
const [showReasonModal, setShowReasonModal] = useState(false);
const [moveReason, setMoveReason] = useState("");
const [currentMove, setCurrentMove] = useState({
  itemId: null,
  sourceColumnId: null,
  dropColumnId: null,
});
useEffect(() => {
  const fetchAllData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        fetchColumns(),
        fetchRecruiters(),
        fetchJobStatuses(),
        fetchJobs(),
        fetchData(),
      ]);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchAllData();
}, []);


  return (
    <React.Fragment>
      <div className="page-content">
        <Toast ref={toast} />
        <Container fluid>
          <div className="page-title-box actjobbread">
            <Row className="align-items-center breadcrumb-card ac-items">
              <Col xl={12} lg={12} md={12} sm={12}>
                <span className="icons-ac">
                  {/* <Dropdown
                    value={selectedRecruiter}
                    onChange={(e) => setSelectedRecruiter(e.value)}
                    options={recruiters}
                    optionLabel="name"
                    placeholder="Recruiter"
                    className="w-full md:w-10rem icons-btn bgclr me-1"
                  /> */}
                  {/* <Dropdown
                    value={selectedJobStatus}
                    onChange={(e) => setSelectedJobStatus(e.value)}
                    options={jobStatusOptions}
                    optionLabel="label"
                    placeholder="Job Status"
                    className="w-full md:w-11rem icons-btn bgclr me-1"
                  /> */}
                  {/* <div className="d-inline me-1 company-auto">
                    <AutoComplete
                      value={value}
                      suggestions={items}
                      completeMethod={search}
                      onChange={(e) => {
                        setValue(e.value);
                        setSelectedCompany(e.value ? { name: e.value } : null);
                      }}
                      placeholder="Company Name"
                    />
                    
                  </div> */}
                  <div className="inline-block">
                    <label className="mt-2 me-2">Select Company</label>
                    <div style={{ display: "inline-block", width: "170px",}} className="me-1">
                      <CompanySelector onCompanyChange={handleCompanyChange} />
                    </div>
                  </div>
                  <Dropdown
                    value={selectedJobTitle}
                    onChange={(e) => setSelectedJobTitle(e.value)}
                    options={jobTitleOptions}
                    optionLabel="name"
                    placeholder="Job Title"
                    className="w-full md:w-10rem icons-btn bgclr me-1"
                  />
                  
                  <InputText
                    value={candidateName}
                    onChange={(e) => setCandidateName(e.target.value)}
                    placeholder="Candidate"
                    className="me-1 md:w-8rem"
                  />
                  
                  {/* <InputText
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    className="me-1 md:w-7rem"
                  /> */}
                  {/* <InputText
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Phone"
                    className="me-1 md:w-7rem"
                  /> */}
                  {/* <InputText
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    placeholder="City"
                    className="me-1 md:w-7rem"
                  /> */}
                  {/* <InputText
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    placeholder="State"
                    className="me-1 md:w-7rem"
                  /> */}
                  {/* <Dropdown
                    value={selectedJob}
                    onChange={(e) => setSelectedJob(e.value)}
                    options={jobOptions}
                    optionLabel="name"
                    placeholder="Job ID"
                    className="w-full md:w-9rem bgclr icons-btn me-2"
                  /> */}
                  <button
                    type="button"
                    className="btn btn-secondary icons-btn me-1 notes"
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary import-res-btn md:w-4rem apply-btn"
                    onClick={applyFilters}
                  >
                    Apply
                  </button>
                </span>
              </Col>
            </Row>
            {loading ? (
              <OrgTableShimmer columns={5} rows={7} titleWidth="220px" />
              ) : (
            <Row className="pt-3">
              <Col lg={12}>
                <div
                  ref={containerRef}
                  className="kanban-row"
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    width: '100%',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    maxHeight: '74vh',
                    paddingBottom: '1rem',
                    scrollbarWidth: 'thin',
                    scrollBehavior: 'smooth'
                  }}
                >
                  {columns.map((column) => (
                    <div
                      key={column.id}
                      id={`column-${column.id}`}
                      className={`flex-none w-80 kanban-view ${currentHoverColumn === column.id ? 'column-hover' : ''}`}
                      onDragOver={(e) => handleColumnDragOver(e, column.id)}
                      onDrop={(e) => onDrop(e, column.id)}
                    >
                      <Card className="bg-gray-100">
                        <div className="flex justify-content-between mb-2 align-items-start">
                          <h3 className="text-gray-700 font-semibold">{column.title}</h3>
                          <Badge
                            value={kanbanData[column.id]?.length || 0}
                            className="bg-blue-500 text-white mb-2"
                          />
                        </div>
                        <div
                          className="min-h-40 p-2 rounded"
                          onDragOver={(e) => onDragOver(e, column.id)}
                          style={{
                            height: "65vh",
                            padding: '8px',
                            transition: 'background-color 0.3s ease',
                            overflowY: 'auto'
                          }}
                        >
                          {getVisibleCards(column.id).map((item) => renderCandidateCard(item, column.id))}
                          {hasMoreCards(column.id) && (
                            <div className="text-center mt-2" style={{ padding: '8px' }}>
                              <Button
                                className="p-button-text p-button-sm"
                                onClick={() => toggleColumnExpand(column.id)}
                                icon={expandedColumns[column.id] ? "pi pi-chevron-up" : "pi pi-chevron-down"}
                                label={expandedColumns[column.id] ? "Show Less" : `Show More (${kanbanData[column.id].length - CARDS_TO_SHOW})`}
                                style={{ width: '100%' }}
                              />
                            </div>
                          )}
                        </div>
                      </Card>
                    </div>
                  ))}
                  {isDragging && (
                    <>
                      <div
                        className="scroll-indicator left"
                        style={{
                          position: 'absolute',
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: '20px',
                          background: 'linear-gradient(to right, rgba(59, 130, 246, 0.2), transparent)',
                          pointerEvents: 'none',
                          zIndex: 10
                        }}
                      />
                      <div
                        className="scroll-indicator right"
                        style={{
                          position: 'absolute',
                          right: 0,
                          top: 0,
                          bottom: 0,
                          width: '20px',
                          background: 'linear-gradient(to left, rgba(59, 130, 246, 0.2), transparent)',
                          pointerEvents: 'none',
                          zIndex: 10
                        }}
                      />
                    </>
                  )}
                </div>
              </Col>
            </Row>)}
          </div>
        </Container>

        <style jsx>{`
          .dragging {
            opacity: 0.5;
          }
          .droppable-container {
            transition: background-color 0.2s ease;
          }
          .droppable-container:hover {
            background-color: #f0f7ff !important;
          }
          .drag-over {
            transform: translateY(2px);
          }
          .column-hover {
            z-index: 5;
          }
          .kanban-view {
            min-width: 300px;
            flex: 0 0 auto;
            display: flex;
            flex-direction: column;
          }
          .p-button-sm {
            font-size: 0.8rem;
          }
          .kanban-row {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            max-height: 74vh;
            -webkit-overflow-scrolling: touch;
          }
          .kanban-row::-webkit-scrollbar {
            height: 8px;
          }
          .kanban-row::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.3);
            border-radius: 4px;
          }
          .kanban-row::-webkit-scrollbar-track {
            background-color: rgba(0, 0, 0, 0.1);
          }
          .min-h-40 {
            min-height: 100px;
          }
        `}</style>
      </div>
      <Modal
  isOpen={showReasonModal}
  toggle={() => setShowReasonModal(false)}
  centered
>
  <ModalHeader toggle={() => setShowReasonModal(false)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
    Reason for Moving Candidate to {columns.find(col => col.id === currentMove.dropColumnId)?.title}
  </ModalHeader>
  <ModalBody>
    <div style={{ marginBottom: 20 }}>
      <label style={{ fontWeight: 500, marginBottom: 5, display: "block" }}>
        Enter Reason <span className="text-danger">*</span>
      </label>
      <textarea
        value={moveReason}
        onChange={(e) => setMoveReason(e.target.value)}
        placeholder="Why are you moving this candidate?"
        rows={4}
        style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
      />
    </div>
  </ModalBody>
 <ModalFooter className="justify-content-center">
  <button className="btn border blueBtn" onClick={() => setShowReasonModal(false)}>
    Cancel
  </button>
  <span
  title={!moveReason.trim() ? "Please enter reason" : ""}
  className="mt-2"
>
  <button
    className="btn border addBtn"
    onClick={handleConfirmMove}
    disabled={isSubmitting || !moveReason.trim()}
  >
    {isSubmitting ? (
      <>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        Submitting...
      </>
    ) : (
      "Submit"
    )}
  </button>
</span>

</ModalFooter>

</Modal>

    </React.Fragment>
  );
};

export default KanbanView;